/*
 *   File : investmentBreakdown.js
 *   Description : Structured tooltip for investment current-value breakdown
 */

import React from 'react';
import styles from '../../styles/components/iconStyleToolTip.module.scss';

const _formatAmount = (val) => {
    if (val == null || val === '') return '₹0';
    if (typeof val === 'string' && val.includes('₹')) return val;
    const num = Number(val);
    if (!Number.isFinite(num)) return String(val);
    return `₹${num.toLocaleString('en-IN')}`;
};

const _BreakdownRow = ({ label, value, sub = false }) => (
    <div className={`${styles.e_breakdown_row} ${sub ? styles.e_breakdown_sub : ''}`}>
        <span>{label}:</span>
        <span className={styles.e_breakdown_value}>{_formatAmount(value)}</span>
    </div>
);

export default function InvestmentBreakdownTooltip({ className = '', data = {} }) {
    const showExternal = data.external_redemption != null;

    return (
        <div className={`${styles.e_icon_tooltip} ${className}`}>
            <div className={styles.e_breakdown}>
                <p className={styles.e_breakdown_title}>Current value breakdown</p>
                <hr className={styles.e_breakdown_divider} />
                <_BreakdownRow label="Invested" value={data.invested_amount} />
                <_BreakdownRow label="Redemption" value={data.total_redemption} />
                <_BreakdownRow label="On Rebalancing" value={data.redemption_from_rebalance} sub />
                <_BreakdownRow label="By Customer" value={data.normal_redemption} sub />
                {showExternal && (
                    <_BreakdownRow label="External redemption" value={data.external_redemption} sub />
                )}
            </div>
        </div>
    );
}
